import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import KeyboardForSearchBar from '../items/KeyboardForSearchBar';

const useStyles = makeStyles({
  underline: {
    '&&&:before': {
      borderBottom: 'none',
    },
    '&&:after': {
      borderBottom: 'none',
    },
  },
});

const useStyles1 = makeStyles({
  paper1: {
    fontFamily: 'Gilroy-SemiBold',
  },
  paper2: {
    visibility: 'hidden',
  },
});

function SearchBar(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const { langs } = props;
  const classes = useStyles();
  const class1 = useStyles1();
  let result = JSON.parse(localStorage.getItem('products'));
  let machineID = JSON.parse(localStorage.getItem('machine'))?._id;
  const [show, setShow] = useState(false);
  const [input, setInput] = useState('');

  const goToProd = (v) => {
    history.push(`/machineUI/product/${machineID}/${v._id}/${v.idx}`);
  };

  const setShowhide = (v) => {
    setShow(false);
  };

  const setShowshow = (v) => {
    setShow(true);
  };

  return (
    <div
    // onClick={() => {
    //   keyboard.current.value = 'wewe';
    // }}
    >
      <Autocomplete
        className="searchBar"
        id="search-bar"
        options={result}
        classes={input === '' ? { paper: class1.paper2 } : { paper: class1.paper1 }}
        inputValue={input}
        onChange={(e, v) => goToProd(v)}
        getOptionLabel={(option) => {
          return option.name[langs] && option.name[langs] !== ''
            ? option.name[langs]
            : option.name?.en;
        }}
        renderInput={(params) => (
          <TextField
            onClick={() => {
              setInput('');
            }}
            {...params}
            id="mydd"
            placeholder={t('Search the store')}
            InputProps={{ ...params.InputProps, classes }}
            InputLabelProps={{ style: { color: 'white' } }}
            onFocus={setShowshow}
            onBlur={setShowhide}
          />
        )}
      />
      {/* <div
        onClick={() => {
          console.log('click');

        }}
      >
        werwe
      </div> */}
      <KeyboardForSearchBar show={show} setShow={setShow} setInput={setInput} searchBar={true} />
    </div>
  );
}
export default SearchBar;
